import { Editor, Range } from "slate";
import { ReactEditor } from "slate-react";

interface PositionPopoverParams {
    editor: Editor;
    target: Range;
    anchorRef: React.RefObject<HTMLSpanElement | null>;
    containerRef: React.RefObject<HTMLDivElement | null>;
    /** Which edge of the cursor line the anchor sits on. Defaults to `bottom`. */
    edge?: "top" | "bottom";
}

export function positionPopoverAtCursor({
    editor,
    target,
    anchorRef,
    containerRef,
    edge = "bottom",
}: PositionPopoverParams): void {
    if (!anchorRef.current || !containerRef.current) {
        return;
    }

    try {
        const domRange = ReactEditor.toDOMRange(editor, target);
        const rect = domRange.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();
        const lineEdge = edge === "top" ? rect.top : rect.bottom;

        anchorRef.current.style.top = `${lineEdge - containerRect.top}px`;
        anchorRef.current.style.left = `${rect.left - containerRect.left}px`;
    } catch {
        // Range may be invalid
    }
}
